/**
 * Kumbara — /kumbara-zeplin-49. Sadece efe@heyglowy.com, menüde yok.
 * Glowy kâr/zarar: kesilen faturalar − gelen bütün faturalar (Efe kararı, 5 Kas).
 * Veri /api/kz49 (backend e-posta kilitli, services/parasutOzet.js).
 */
import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { apiFetch } from '../utils/apiFetch';

const API = 'https://api.glowytics.com/api/kz49';

const T = {
  kart: '#FFFFFF', cizgi: '#E5E7EB', cizgi2: '#F3F4F6', zemin: '#F8FAFF',
  metin: '#111827', metin2: '#374151', metin3: '#6B7280', mavi: '#436AEB', maviAcik: '#EEF2FF',
  kirmizi: '#DC2626', turuncu: '#B45309', turuncuZemin: '#FFFBEB', turuncuCizgi: '#FDE68A', yesil: '#059669',
};

const AY = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const ayAdi = (m) => (m ? `${AY[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : '—');
const tl = (x) => `₺${Math.round(x || 0).toLocaleString('tr-TR')}`;
const kisaTl = (x) => {
  const a = Math.abs(x || 0);
  if (a >= 1e6) return `₺${(x / 1e6).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} M`;
  if (a >= 1e3) return `₺${Math.round(x / 1e3).toLocaleString('tr-TR')} B`;
  return tl(x);
};
const tarih = (iso) => (iso ? new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', timeZone: 'Europe/Istanbul' }) : '—');
// Türkçe büyük harflerde \b çalışmıyor; kelimelere bölüp şirket eklerini at.
const EK = new Set(['TİCARET', 'TIC.', 'TİC.', 'SANAYİ', 'SAN.', 'ANONİM', 'ŞİRKETİ', 'LİMİTED', 'LTD.', 'LTD', 'ŞTİ.', 'ŞTİ', 'A.Ş.', 'AŞ', 'VE', 'İŞLETMECİLİĞİ',
  'MAĞAZACILIK', 'MALZEMELERİ', 'ÜRÜNLERİ', 'PAZARLAMA', 'DANIŞMANLIK', 'TEKSTİL', 'GİYİM', 'E-TİCARET', 'DIŞ', 'İÇ', 'İLETİŞİM', 'BİLİŞİM', 'YATAK', 'YORGAN',
  'SANAYI', 'ŞİRKETİ', 'İŞLETMELERİ', 'HİZMETLERİ', 'HIZMETLER', 'ENDÜSTRİ', 'DİJİTAL', 'İNTERNET', 'KİRALAMA', '.', 'PAZ.A.Ş.', 'MODA', 'SPOR']);
const kisaAd = (ad = '') => {
  const k = ad.split(/\s+/).filter((w) => w && !EK.has(w.toLocaleUpperCase('tr-TR')));
  return (k.length ? k : ad.split(/\s+/)).slice(0, 2).join(' ');
};

const th = { textAlign: 'right', fontSize: 12, fontWeight: 600, color: T.metin3, padding: '8px 10px', borderBottom: `1px solid ${T.cizgi}`, whiteSpace: 'nowrap' };
const td = { textAlign: 'right', fontSize: 13, color: T.metin2, padding: '9px 10px', borderBottom: `1px solid ${T.cizgi2}`, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' };
const solTh = { ...th, textAlign: 'left' };
const solTd = { ...td, textAlign: 'left', color: T.metin };

function Kutu({ baslik, sag, children }) {
  return (
    <div style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 18, marginBottom: 16, overflowX: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 12 }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.metin }}>{baslik}</div>
        {sag && <div style={{ marginLeft: 'auto', fontSize: 12, color: T.metin3 }}>{sag}</div>}
      </div>
      {children}
    </div>
  );
}

function Kpi({ baslik, deger, alt, renk, kucuk }) {
  return (
    <div style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 16, minWidth: 0 }}>
      <div style={{ fontSize: 12, color: T.metin3, marginBottom: 6 }}>{baslik}</div>
      <div style={{ fontSize: kucuk ? 19 : 24, fontWeight: 700, color: renk || T.metin, letterSpacing: -0.3, whiteSpace: 'nowrap' }}>{deger}</div>
      <div style={{ fontSize: 12, color: T.metin3, marginTop: 6, lineHeight: 1.45 }}>{alt}</div>
    </div>
  );
}

function Cubuk({ deger, enCok, renk }) {
  return (
    <div style={{ height: 6, background: T.cizgi2, borderRadius: 3, width: 64, display: 'inline-block', verticalAlign: 'middle', marginLeft: 8 }}>
      <div style={{ height: 6, borderRadius: 3, background: renk, width: `${Math.min(100, Math.max(0, (deger / enCok) * 100))}%` }} />
    </div>
  );
}

export default function Kumbara() {
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = async (taze = false) => {
    setYukleniyor(true); setHata(null);
    try {
      const r = await apiFetch(`${API}${taze ? '?taze=1' : ''}`, { headers: { 'Content-Type': 'application/json' } });
      const g = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(g.error || `HTTP ${r.status}`);
      setVeri(g);
    } catch (e) { setHata(e.message); } finally { setYukleniyor(false); }
  };
  useEffect(() => { yukle(); }, []);

  if (hata) return <div style={{ padding: 32, color: T.kirmizi }}>{hata}</div>;
  if (!veri) return <div style={{ padding: 32, color: T.metin3 }}>Paraşüt'ten okunuyor…</div>;

  const t = veri.toplam;
  const eksik = new Set(veri.eksikAylar);
  const tamAylar = veri.aylar.filter((m) => !eksik.has(m.ay));
  const topla = (liste, k) => liste.reduce((s, m) => s + m[k], 0);
  const gelirliAy = veri.aylar.filter((m) => m.gelir > 0).length;
  const tamGelirliAy = tamAylar.filter((m) => m.gelir > 0).length;
  const tamKar = topla(tamAylar, 'kar');
  const tamMarj = topla(tamAylar, 'medyaMarj');
  const enCokGider = Math.max(1, ...veri.giderTurleri.map((g) => g.tutar));
  const giderTop = veri.giderTurleri.reduce((s, g) => s + g.tutar, 0);
  const karRenk = (x) => (x < 0 ? T.kirmizi : T.yesil);
  const donemAdi = (l) => `${ayAdi(l[0]?.ay)} – ${ayAdi(l[l.length - 1]?.ay)}`;
  const grupTh = { ...th, textAlign: 'center', fontSize: 11, color: T.metin3, borderBottom: `2px solid ${T.cizgi}`, paddingBottom: 4 };
  const ayrac = { borderLeft: `1px solid ${T.cizgi}` };

  return (
    <div style={{ padding: '24px 28px', background: T.zemin, minHeight: '100vh', maxWidth: 1240 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 18, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, color: T.metin }}>Glowy kâr / zarar</div>
          <div style={{ fontSize: 13, color: T.metin3, marginTop: 4 }}>
            Paraşüt · kesilen faturalar − gelen faturalar · fatura tarihine göre, KDV hariç · güncelleme {tarih(veri.guncellendi)} {new Date(veri.guncellendi).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
        <button type="button" onClick={() => yukle(true)} disabled={yukleniyor} style={{
          marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8,
          border: `1px solid ${T.cizgi}`, background: T.kart, color: T.metin2, fontSize: 13, cursor: yukleniyor ? 'wait' : 'pointer',
        }}>
          <RefreshCw size={14} style={yukleniyor ? { animation: 'spin 1s linear infinite' } : undefined} /> {yukleniyor ? 'Okunuyor (~20 sn)' : "Paraşüt'ten yenile"}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginBottom: 16 }}>
        <Kpi baslik={`Medya hariç gelir · ${donemAdi(veri.aylar)}`} deger={kisaTl(t.kendiGelir)}
          alt={<>Aylık ort. {kisaTl(t.kendiGelir / Math.max(1, gelirliAy))} · ajans {kisaTl(t.hizmetGelir)}, yazılım {kisaTl(t.yazilimGelir)}, web {kisaTl(t.webGelir)}</>} />
        <Kpi baslik={`Safkan kâr · ${donemAdi(veri.aylar)}`} deger={kisaTl(t.safkanKar)} renk={karRenk(t.safkanKar)}
          alt={<>Medya hariç gelir − medya dışı giderler (maaş dahil) · aylık ort. {kisaTl(t.safkanKar / Math.max(1, gelirliAy))}</>} />
        <Kpi baslik={`Medya marjı · ${donemAdi(tamAylar)}`} deger={kisaTl(tamMarj)} renk={karRenk(tamMarj)}
          alt={<>Medya geliri − Google/Liberdatum · Google faturası gelmiş aylar</>} />
        <Kpi baslik={`Toplam kâr · ${donemAdi(tamAylar)}`} deger={kisaTl(tamKar)} renk={karRenk(tamKar)}
          alt={<>Aylık ort. {kisaTl(tamKar / Math.max(1, tamGelirliAy))} · iadeler ({kisaTl(t.iadeGider)}) dahil</>} />
      </div>

      <Kutu baslik="Ay ay" sag="Gider = o ay gelen bütün faturalar (reddedilenler hariç)">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ ...grupTh, borderBottom: 'none' }} />
              <th colSpan={3} style={grupTh}>Safkan (medya hariç)</th>
              <th colSpan={3} style={{ ...grupTh, ...ayrac }}>Medya</th>
              <th style={{ ...grupTh, ...ayrac }}>Hepsi</th>
            </tr>
            <tr>
              <th style={solTh}>Ay</th>
              <th style={th}>Gelir</th>
              <th style={th}>Gider</th>
              <th style={th}>Safkan kâr</th>
              <th style={{ ...th, ...ayrac }}>Faturalanan</th>
              <th style={th}>Google + Liberdatum</th>
              <th style={th}>Marj</th>
              <th style={{ ...th, ...ayrac }}>Toplam kâr</th>
            </tr>
          </thead>
          <tbody>
            {veri.aylar.map((m) => {
              const ek = eksik.has(m.ay);
              return (
                <tr key={m.ay} style={ek ? { background: T.turuncuZemin } : undefined}>
                  <td style={solTd}>
                    {ayAdi(m.ay)}
                    {ek && <span style={{ marginLeft: 8, fontSize: 11, color: T.turuncu, fontWeight: 600 }}>Google faturası gelmedi</span>}
                  </td>
                  <td style={{ ...td, color: T.metin }}>{tl(m.kendiGelir)}</td>
                  <td style={td}>{tl(m.digerGider - m.iadeGider)}</td>
                  <td style={{ ...td, color: karRenk(m.safkanKar), fontWeight: 700 }}>{tl(m.safkanKar)}</td>
                  <td style={{ ...td, ...ayrac, color: T.metin3 }}>{tl(m.medyaGelir)}</td>
                  <td style={{ ...td, color: T.metin3 }}>{tl(m.medyaGider)}</td>
                  <td style={{ ...td, color: ek ? T.turuncu : karRenk(m.medyaMarj), fontWeight: 600 }}>{tl(m.medyaMarj)}</td>
                  <td style={{ ...td, ...ayrac, color: ek ? T.turuncu : karRenk(m.kar), fontWeight: 700 }}>{tl(m.kar)}</td>
                </tr>
              );
            })}
            <tr>
              <td style={{ ...solTd, fontWeight: 700, borderBottom: 'none' }}>Toplam</td>
              <td style={{ ...td, fontWeight: 700, color: T.metin, borderBottom: 'none' }}>{tl(t.kendiGelir)}</td>
              <td style={{ ...td, fontWeight: 700, borderBottom: 'none' }}>{tl(t.digerGider - t.iadeGider)}</td>
              <td style={{ ...td, fontWeight: 700, color: karRenk(t.safkanKar), borderBottom: 'none' }}>{tl(t.safkanKar)}</td>
              <td style={{ ...td, ...ayrac, fontWeight: 700, borderBottom: 'none' }}>{tl(t.medyaGelir)}</td>
              <td style={{ ...td, fontWeight: 700, borderBottom: 'none' }}>{tl(t.medyaGider)}</td>
              <td style={{ ...td, fontWeight: 700, borderBottom: 'none' }}>{tl(t.medyaMarj)}</td>
              <td style={{ ...td, ...ayrac, fontWeight: 700, borderBottom: 'none' }}>{tl(t.kar)}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ fontSize: 12, color: T.metin3, marginTop: 10, lineHeight: 1.6 }}>
          Safkan gider = medya dışı gelen faturalar (Ayten Yağmur dahil, iadeler hariç). Toplam kâr = safkan kâr + medya marjı − iadeler ({kisaTl(t.iadeGider)}).
          Google (ALLTOGETHER) ay sonunda faturalıyor, High5 bütçesi ay başında kesiliyor; Mart hizmetleri 1 Nisan'da faturalandı.
          Fatura olarak gelmeyen ödemeler (SGK, vergi, kartla ödenen yurtdışı reklam, e-Arşiv/makbuz ile gelip Paraşüt'e girilmeyenler) bu hesapta yok.
          {veri.reddedilen?.length > 0 && <> Reddedilen {veri.reddedilen.length} fatura ({kisaTl(veri.reddedilen.reduce((s, r) => s + r.tutar, 0))}) sayılmadı.</>}
        </div>
      </Kutu>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(520px, 1fr))', gap: 16 }}>
        <Kutu baslik="Müşteriler" sag={`${veri.musteriler.length} cari`}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>
              <th style={solTh}>Müşteri</th><th style={th}>Medya</th><th style={th}>Kendi gelirimiz</th><th style={th}>Açık</th><th style={th}>Vadesi geçen</th>
            </tr></thead>
            <tbody>
              {veri.musteriler.map((m) => (
                <tr key={m.ad}>
                  <td style={solTd} title={m.ad}>{kisaAd(m.ad)}</td>
                  <td style={td}>{m.medya ? kisaTl(m.medya) : '—'}</td>
                  <td style={{ ...td, color: T.metin, fontWeight: 600 }}>{kisaTl(m.hizmet)}</td>
                  <td style={td}>{m.acik ? kisaTl(m.acik) : '—'}</td>
                  <td style={{ ...td, color: m.gecikmis ? T.kirmizi : T.metin3 }}>{m.gecikmis ? kisaTl(m.gecikmis) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Kutu>

        <div>
          <Kutu baslik="Giderler türe göre" sag={`kayıtlı toplam ${kisaTl(giderTop)}`}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                {veri.giderTurleri.map((g) => (
                  <tr key={g.kod}>
                    <td style={solTd}>{g.tur}</td>
                    <td style={td}><Cubuk deger={g.tutar} enCok={enCokGider} renk={g.kod === 'medya' ? T.mavi : '#94A3B8'} /></td>
                    <td style={td}>{tl(g.tutar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Kutu>

          <Kutu baslik="Tedarikçiler" sag="KDV hariç">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={solTh}>Tedarikçi</th><th style={solTh}>Tür</th><th style={th}>Tutar</th></tr></thead>
              <tbody>
                {veri.tedarikciler.slice(0, 14).map((s) => (
                  <tr key={s.ad + s.tur}>
                    <td style={solTd} title={s.ad}>{kisaAd(s.ad)} <span style={{ color: T.metin3, fontSize: 12 }}>×{s.adet}</span></td>
                    <td style={{ ...solTd, color: T.metin3 }}>{s.tur}</td>
                    <td style={td}>{tl(s.tutar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Kutu>
        </div>
      </div>

      <Kutu baslik="Vadesi geçen faturalar" sag={`${veri.vadesiGecen.length} fatura · ${tl(t.gecikmisAlacak)}`}>
        {veri.vadesiGecen.length === 0 ? <div style={{ fontSize: 13, color: T.metin3 }}>Yok.</div> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>
              <th style={solTh}>Müşteri</th><th style={solTh}>Fatura no</th><th style={th}>Fatura</th><th style={th}>Vade</th><th style={th}>Gecikme</th><th style={th}>Kalan (KDV dahil)</th>
            </tr></thead>
            <tbody>
              {veri.vadesiGecen.map((f) => (
                <tr key={f.no}>
                  <td style={solTd} title={f.cari}>{kisaAd(f.cari)}</td>
                  <td style={{ ...solTd, color: T.metin3 }}>{f.no}</td>
                  <td style={td}>{tarih(f.tarih)}</td>
                  <td style={td}>{tarih(f.vade)}</td>
                  <td style={{ ...td, color: f.gun > 30 ? T.kirmizi : T.turuncu, fontWeight: 600 }}>{f.gun} gün</td>
                  <td style={td}>{tl(f.kalan)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Kutu>

      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}
